import type { OnlineSection } from 'tm3-core/api.dtos';

function parseParams(sections: OnlineSection[]): OnlineSection[] {
  return sections.map((sec) => {
    for (let key in sec.params) {
      let value = sec.params[key];
      if (value == 'true' || value == 'false') sec.params[key] = value === 'true';
    }
    return sec;
  });
}

export default parseParams;
